import Innovid from '../components/Innovid'; // ✅ Import your component

function Innovid1() {
  return (
    <div>
      <h1>https://www.cvs.com</h1>
      {/* <h1>Leanderboard(1280x100)</h1>
      <h1>Anchor(1280x300)</h1>
      <h1>skyscraper(240x620)</h1>
      <h1>Interrepter(1040x100)</h1> */}
      <Innovid /> {/* ✅ Use imported component */}
    </div>
  );
}

export default Innovid1;
